import React, { useContext } from 'react'
import SearchResult from '@Components/WorkRegistrationSubs/SearchResult'
import { formatName } from '@App/helpers/format-name'
import { StoresContext } from '@App/contexts'
import { Maybe } from '@Types'
import { IPIValidator } from '@App/helpers/validate'
import { observer } from 'mobx-react'
import { WriterModel } from '@Entities/work/writer-model'
import { WriterSearchResults } from '@Entities/work/writer-search-results'

interface WriterResultsProps {
    setFoundWriterToDraft: (writer: WriterModel, closePopup: boolean) => void
}

const WriterResults = ({ setFoundWriterToDraft }: WriterResultsProps) => {
    const { writerSearchStore, workStore } = useContext(StoresContext)

    const itemWasAdded = (ipId: Maybe<string>) => {
        const workDraftFromLocal = workStore.workDraftLocal
        if (!workDraftFromLocal) {
            return
        }

        return workDraftFromLocal.writers.some((item: WriterModel) => ipId === item.ipId)
    }

    const writerRoles = (searchResult: WriterSearchResults) => {
        if (searchResult.entity.ipiNumber && IPIValidator(searchResult.entity.ipiNumber, false)) {
            return [{ name: 'IPI Number', value: searchResult.entity.ipiNumber }]
        }

        return []
    }

    return (
        <>
            <p className="suggested-title">Pick from Suggested Writers</p>
            <div className="suggested">
                {writerSearchStore.writersSearchModel?.results.map((data: WriterSearchResults) => (
                    <SearchResult
                        key={data.entity.id}
                        title={formatName(data.entity.firstName, data.entity.lastName)}
                        onAddClicked={() => setFoundWriterToDraft(data.entity, true)}
                        onItemWasAdded={() => itemWasAdded(data.entity.ipId)}
                        roles={writerRoles(data)}
                        addButtonText="Add writer"
                    />
                ))}
            </div>
        </>
    )
}

export default observer(WriterResults)
